/* eslint-disable camelcase */
import { node } from "~/util/dom";
import { getDetailImage, getImage2200x2200 } from "~/util/cdn";
import { IReviewItem, IReviewPhotoImage } from "~/review/interfaces";
import { _ } from "~/i18n";
import { CONFIG } from "~/config";

function createImage(image: IReviewPhotoImage, createOverlay: boolean, count: number, onClick: (image: IReviewPhotoImage) => void): HTMLDivElement {
	const photoItem = node("div", {
		className: "photo-item",
	}) as HTMLDivElement;

	photoItem.addEventListener("click", () => {
		onClick(image);
	});
	const photo = node("img", { src: getDetailImage(image.urls.default) });

	if (CONFIG.wasmEnabled) {
		photo.crossOrigin = "anonymous";
	}

	photoItem.append(photo);

	if (createOverlay) {
		const overlay = node("div", {
			className: "overlay",
		});
		const overlayText = node("span", { className: "overlay-text", textContent: `+${count}` });

		overlay.append(overlayText);
		photoItem.append(overlay);
	}

	return photoItem;
}

interface IReviewPhotoData extends Partial<IReviewItem>{
	poi?: {
		source: string;
		id: string | number;
		title: string;
		poitypeId?: number;
		mark: {
			lon: number;
			lat: number;
		}
	};
}

interface ICreateReviewPhotos {
	reviewData: IReviewPhotoData;
	maxPhotos?: number;
	maxSize?: number;
}

export function createReviewPhotos({
	reviewData = {
		id: 0,
		gallery: [],
		updated: "",
		user: {
			image_url: "",
			name: "",
			public_id: "",
			review_count: 0,
			bank_id: true,
			hasPremium: false,
			isFanda: false,
		},
	},
	maxPhotos = 3,
	maxSize = 2200,
}: ICreateReviewPhotos): HTMLDivElement {
	const container = node("div", {
		className: "review-photos",
	}) as HTMLDivElement;
	const galleryCount = reviewData.gallery.length;

	function onClick(image: IReviewPhotoImage) {
		const list = reviewData.gallery.map(item => {
			let width = item.size[0];
			let height = item.size[1];
			const ratio = width / height;

			if (width > maxSize || height > maxSize) {
				if (width > height) {
					width = maxSize;
					height = Math.floor(maxSize / ratio);
				} else {
					height = maxSize;
					width = Math.floor(maxSize * ratio);
				}
			}

			return {
				urls: [{
					url: getImage2200x2200(item.urls.default),
					urlType: "full",
				}, {
					url: item.urls.default,
					urlType: "placeholder",
				}],
				width,
				height,
				date: reviewData.updated,
				name: "",
				approved: true,
				id: item.id,
				source: "foto",
				author: {
					avatarUrl: "",
					name: "no-name",
					userPublicId: "",
					reviewCount: 0,
					userSource: "rus",
					...reviewData.user
						? {
							avatarUrl: reviewData.user.image_url,
							name: reviewData.user.name,
							userPublicId: reviewData.user.public_id,
							reviewCount: reviewData.user.review_count,
						}
						: {},
				},
				status: item.status,
				language: reviewData.lang ? reviewData.lang : null,
				likes: item.likes,
				...reviewData.poi
					? {
						entityPoiTypeId: reviewData.poi.poitypeId,
						entityId: reviewData.poi.id,
						entitySource: reviewData.poi.source,
						entityTitle: reviewData.poi.title,
						mark: reviewData.poi.mark,
					}
					: {},
				review: {
					updated: reviewData.updated,
					structured_rating: reviewData.structured_rating,
					rating: reviewData.rating,
					text: reviewData.text,
					native: !!reviewData.native,
					lang: reviewData.lang,
				},
			};
		});

		Mapy.getComponent("photoDetail").setData({
			list,
			count: list.length,
			id: image.id,
			source: "foto",
			backTitle: _("review.backToReviews"),
			galleryType: "review",
		}).activate();

		Mapy.getComponent("history").save();
	}

	reviewData.gallery.slice(0, maxPhotos).forEach((item, ind) => {
		const createOverlay = ind === maxPhotos - 1 && galleryCount > maxPhotos;

		container.append(createImage(item, createOverlay, galleryCount - maxPhotos, onClick));
	});

	return container;
}
